// extracted by mini-css-extract-plugin
export default {"rateBox":"MovieSliderCard_rateBox__V1byz"};